<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.book.editBookBundle')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">
                <back-button></back-button>

                <!-- <b-alert v-model="disableEditForm" variant="info">{{showFormMessage}}</b-alert> -->


                <b-alert v-model="showDisableAlert"  variant="info"> {{disableEditFormMessage}}
                    <button v-if="!firstLoad && sessionCreated" @click="checkForEdit(true)">
                         <i class="fas fa-sync"></i>
                    </button>
                </b-alert>


                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <div class="card">
                    <div class="card-header bg-light">
                        <div class="card-title">{{$t('form.book.editBookBundle')}}</div>
                        <div class="text-right">
                            <b-button @click="download()">{{$t('button.bookList')}}</b-button>
                            <b-button variant="primary" @click="update()" :disabled="disableEditForm || readonly">
                                {{$t('button.update')}}</b-button>
                            <button class="btn btn-info" @click="update(true)"
                                :disabled="disableEditForm || readonly">{{$t('button.updateClose')}}</button>

                        </div>
                    </div>
                    <div class="card-body">
                        <b-tabs content-class="mt-3">
                            <b-tab :title="$t('form.book.tabGeneral')" active>
                                <div class="row">
                                    <div class="col-md-8">
                                        <div class="form-group">
                                            <label for="DiscriptionField">{{$t('form.book.description')}}<span
                                                    class="text-danger">*</span> </label>
                                            <textarea id="DiscriptionField" rows="3" class="form-control"
                                                v-model.trim="$v.bookBundle.Description.$model"
                                                :class="{ 'is-invalid': $v.bookBundle.Description.$error }"></textarea>
                                            <div class="invalid-feedback" v-if="!$v.bookBundle.Description.required">
                                                {{$t('form.validation.required')}}</div>
                                            <div class="invalid-feedback" v-if="!$v.bookBundle.Description.maxLength">
                                                {{$t('form.validation.maxLength', {num: $v.bookBundle.Description.$params.maxLength.max})}}
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label for="CreationDateField">{{$t('form.book.creationDate')}}<span
                                                    class="text-danger">*</span></label>
                                            <input id="CreationDateField" type="date" class="form-control"
                                                v-model.trim="$v.bookBundle.CreatedOn.$model"
                                                :class="{ 'is-invalid': $v.bookBundle.CreatedOn.$error }">
                                            <div class="invalid-feedback" v-if="!$v.bookBundle.CreatedOn.required">
                                                {{$t('form.validation.required')}}</div>
                                        </div>

                                        <hr>

                                        <h4>{{$t('form.book.books')}}</h4>

                                        <div class="table-responsive">
                                            <table class="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>{{$t('form.book.title')}}</th>
                                                        <th>{{$t('form.book.author')}}</th>
                                                        <th>{{$t('form.book.publisher')}}</th>
                                                        <th>{{$t('form.book.edition')}}</th>
                                                        <th>{{$t('form.book.ISBN')}}</th>
                                                        <th v-if="!readonly"></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(book,index) in selectedBooks" :key="index">
                                                        <td>{{book.Title}}</td>
                                                        <td>{{book.Author}}</td>
                                                        <td>{{book.Publisher}}</td>
                                                        <td>{{book.Edition}}</td>
                                                        <td>{{book.ISBN}}</td>
                                                        <td class="text-right" v-if="!readonly">
                                                            <span style="color:red; cursor:pointer"
                                                                @click="removeBook(index)">
                                                                <i class="fa fa-times"></i>
                                                            </span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                    <div class="col-md-4" v-if="!readonly">
                                        <div class="form-group shadow p-3">
                                            <label>{{$t('form.book.searchBooks')}}</label>
                                            <ul class="list-group m-0">
                                                <div class="input-group">
                                                    <input type="text" class="form-control"
                                                        :placeholder="$t('form.book.addBookBundle')" v-model="bookTitle"
                                                        @keyup="searchBook">
                                                    <div class="input-group-append">
                                                        <span class="input-group-text" @click="clear()"
                                                            style="color:red;cursor:pointer;">
                                                            <i class="fa fa-times"></i></span>
                                                    </div>
                                                </div>
                                                <li class="list-group-item searchCourseBackground"
                                                    v-for="(book,index) in books" v-bind:key="index"
                                                    @click="addBook(book)" style="cursor:pointer">

                                                    {{book.Title }}  <span v-if="book.Edition"> {{' - Edition: ' +book.Edition }}</span>

                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </b-tab>

                            <b-tab :title="$t('form.book.tabAudit')">
                                <b-table id="my-table" :items="audits" :per-page="perPageAudits" sort-by="date"
                                    :sort-desc="true" :current-page="currentPage" :fields="fields" small hover bordered
                                    responsive>
                                </b-table>

                                <b-pagination v-if="totalAudits" v-model="currentPage" :total-rows="totalAudits"
                                    :per-page="perPageAudits" aria-controls="my-table" align="center" pills>
                                </b-pagination>
                            </b-tab>
                        </b-tabs>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {
        required,
        minLength,
        maxLength,

    } from "vuelidate/lib/validators";

    export default {

        props: ['permissions', 'editFormInterval', 'datetimeFormat'],

        data() {
            return {
                alert: false,
                alertClass: '',
                alertMessage: '',

                isLoading: false,
                fullPage: true,

                request_source: '',
                interval: '',
                showFormMessage: '',
                disableEditFormMessage: '',
                disableEditForm: false,
                closing: true,

                showDisableAlert: false,
                firstLoad:true,
                sessionCreated:true,
                continueInterVal:true,


                // audits custom pagination
                currentPage: 1,
                perPageAudits: 5,
                fields: ['field', 'oldValue', 'newValue', 'userName', 'createdAt'],

                bookTitle: '',

                bookBundle: {
                    Description: null,
                    CreatedOn: null,
                },

                books: [],
                selectedBooks: [],
                audits: []
            }
        },

        validations: {
            bookBundle: {
                Description: {
                    required,
                    maxLength: maxLength(255)
                },

                CreatedOn: {
                    required
                }
            }
        },

        mounted() {
            if (!this.permissions.viewBookbundles) {
                this.$router.push('/');
                return;
            }

            if (this.permissions.editBookbundles) {
                this.checkForEdit();
                let self = this;
                this.interval = setInterval(() => {
                    if(self.continueInterVal)
                    self.checkForEdit();
                    }, this.editFormInterval);
            }

            this.getAuditsPaginate();
            this.getBookBundle();
        },

        computed: {
            totalAudits() {
                return this.audits.length
            },

            readonly() {
                return !this.permissions.editBookbundles;
            }
        },

        watch: {
            bookBundle: {
                handler(val) {
                    this.closing = false;
                },
                deep: true
            },

            selectedBooks: {
                handler(val) {
                    this.closing = false;
                },
                deep: true
            },
        },

        methods: {

            async createToken() {
                let response = await axios.post('/api/api-tokens', {
                    type: 'bookbundle-export'
                });
                let token = '';

                if (response.status == 200) {
                    token = response.data.extra[0].token
                }

                return token;
            },

            async download() {
                let token = await this.createToken();

                if (token == '') return;

                window.open(`/bookbundles/${this.bookBundle.ID}/export?token=${token}`, '_blank');
            },

            getAuditsPaginate() {
                axios
                    .get('/api/audits-paginate')
                    .then(({
                        data
                    }) => this.perPageAudits = data);
            },

            searchBook() {
                if (this.bookTitle == '') {
                    this.clear();
                    return;
                }

                let source = axios.CancelToken.source();

                if (this.request_source != '')
                    this.request_source.cancel('Operation canceled by the user.');

                this.request_source = source;

                axios
                    .get(`/api/books?title=${this.bookTitle}`, {
                        cancelToken: this.request_source.token
                    }).then(response => {
                        this.books = response.data.data.data;
                    }).catch(error => {
                        console.log('error fetching books');
                    });
            },

            addBook(book) {
                this.selectedBooks.push(book);
                this.clear();
            },

            removeBook(index) {
                this.selectedBooks.splice(index, 1);
            },

            clear() {
                this.books = [];
                this.bookTitle = '';
            },

            async update(shouldClose = false) {

                if (this.disableEditForm) return;

                this.$v.$touch();

                if (this.$v.$invalid) {
                    let errorMsg = '';
                      if(this.$v.bookBundle.Description.$error){
                            errorMsg = 'Description';
                      }

                    if(this.$v.bookBundle.CreatedOn.$error){
                            errorMsg = errorMsg ? errorMsg +"and  Created On": "Created On";
                      }

                    this.showAlert(this.$t('form.validation.mandatoryFieldsError', {errors:errorMsg}), 'danger');
                    return;
                }

                let data = await this.getBookBundleData();

                this.isLoading = true;

                axios
                    .put('/api/bookbundles/' + this.$route.params.id, data)
                    .then(response => {
                        this.isLoading = false;
                        this.closing = true;

                        if (response.data.success) {
                            this.showAlert(response.data.message);

                             if (shouldClose) {
                                    clearInterval(this.interval);
                                    setTimeout(() => this.$router.go(-1), 2000);
                                    return;
                                }
                        }
                    })
                    .catch(error => {
                        this.isLoading = false;

                        console.log('error saving book bundle');
                    });
            },

            getBookBundleData() {
                let books = []
                let bookbundle = {
                    Description: this.bookBundle.Description,
                    CreatedOn: this.bookBundle.CreatedOn,
                }

                this.selectedBooks.forEach(b => books.push(b.ID))

                return {
                    bookbundle,
                    books
                }
            },

            getBookBundle() {
                this.isLoading = true;

                axios
                    .get('/api/bookbundles/' + this.$route.params.id + '/edit')
                    .then(response => {
                        // this.isLoading = false;

                        let data = response.data;

                        this.bookBundle = data.bookbundle;
                        this.selectedBooks = data.bookbundle.books;

                        this.audits = data.audits;
                        this.audits.map(audit => {
                            audit.date = audit.createdAt;
                            audit.createdAt = moment(audit.createdAt).format(this.datetimeFormat);
                        });

                        setTimeout(() => {
                            this.isLoading = false;
                            this.closing = true;
                        }, 2000);
                    }).catch(error => {
                        this.isLoading = false;

                        console.log('error fetching book bundle record');
                    });
            },


            checkForEdit(refresh = false)
            {

                    if(refresh)
                    this.continueInterVal = true;
                    let data= {
                        'field_id':this.$route.params.id,
                        'form':this.$route.name,
                        'refresh':refresh,
                    }
                    // if(refresh) this.showDisableAlert = false;
                    axios
                    .post("/api/check-for-edit-session" , data)
                    .then(response => {

                        this.sessionCreated = true;
                        if (response.data.warning == 0) {

                            this.disableEditForm = false;
                            this.showDisableAlert = false;
                            if(this.firstLoad)
                            {
                                this.firstLoad = false;
                                this.getBookBundle();
                            }
                        }

                        if (response.data.warning == -1) {
                            this.disableEditForm = false ;
                            this.showDisableAlert = false;
                        }

                        if (response.data.warning == 1) {
                             this.firstLoad = false;
                            this.disableEditFormMessage = response.data.message;
                            this.disableEditForm = true;
                            this.showDisableAlert = true;
                            this.continueInterVal = false;
                        }

                        if (response.data.warning == 2) {
                            let msg = response.data.message;
                            if(this.firstLoad){
                              msg.replace('re-open' ,'open');
                            }
                            this.sessionCreated = false;
                            this.disableEditFormMessage = msg;
                            this.disableEditForm = true;
                            this.showDisableAlert = true;
                        }
                        if (response.data.warning == 3) {
                            this.disableEditForm = false;
                            this.showDisableAlert = true;
                            this.disableEditFormMessage = response.data.message;
                        }
                    })
                    .catch(error => {
                        console.log('error');
                    })
                },



            showAlert(msg, cls = 'success') {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            }
        },

        beforeRouteLeave(to, from, next) {
            clearInterval(this.interval);

            if (this.closing) next()
            else {
                const answer = window.confirm(this.$t('leavePrompt'))

                if (answer) {
                    next()
                } else {
                    next(false)
                }
            }
        }

    }

</script>
<style scoped>
    .searchCourseBackground:hover {
        background: #eee;
    }

</style>
